import React, { useState, useImperativeHandle, forwardRef } from 'react';
import { Vehiculo } from '../../types/vehiculo';

export interface VehiclePickerHandles {
    clearSearch: () => void;
}

interface VehiclePickerProps {
    vehicles: Vehiculo[];
    onSelect: (vehicle: Vehiculo) => void;
}

const VehiclePicker = forwardRef<VehiclePickerHandles, VehiclePickerProps>(
    ({ vehicles, onSelect }, ref) => {
        const [searchTerm, setSearchTerm] = useState('');
        const [isOpen, setIsOpen] = useState<boolean>(false);

        const filteredVehicles = vehicles.filter((vehicle: Vehiculo) =>
            vehicle.Placa.toLowerCase().includes(searchTerm.toLowerCase()) || vehicle.NumeroUnidad.toLowerCase().includes(searchTerm.toLowerCase())
        );

        const handleFocus = () => {
            setIsOpen(true);
        };

        const handleBlur = () => {
            setTimeout(() => setIsOpen(false), 200);
        };

        // Exponemos el método clearSearch al componente padre
        useImperativeHandle(ref, () => ({
            clearSearch: () => setSearchTerm(''),
        }));

        return (
            <div className="position-relative">
                <input
                    type="text"
                    className="form-control "
                    placeholder='Buscar por Placa...'
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                />
                {isOpen && (
                    <div className="dropdown-menu show w-100 overflow-auto" style={{ maxHeight: '300px' }}>
                        <ul className="list-group" style={{ maxHeight: '250px' }}>
                            {filteredVehicles.length > 0 ? (
                                filteredVehicles.map((vehicle: Vehiculo, index) => (
                                    <button
                                        type='button'
                                        key={index}
                                        className='dropdown-item text-start'
                                        style={{ cursor: 'pointer' }}
                                        onMouseDown={() => onSelect(vehicle)}
                                        title={`${vehicle.CentroCosto} - ${vehicle.CentroCostoDesc}`}
                                    >
                                        {vehicle.Placa} - {vehicle.NumeroUnidad}
                                    </button>

                                ))

                            ) : (
                                <span className="dropdown-item disabled">
                                    No se encontraron reultados
                                </span>
                            )}
                        </ul>
                    </div>
                )}
            </div>
        );
    }
);

export default VehiclePicker;
